module.exports = {"220605001":"孙家堡子街道","220605002":"江源街道","220605003":"正岔街道","220605004":"城墙街道","220605102":"湾沟镇","220605103":"松树镇","220605104":"砟子镇","220605105":"石人镇","220605106":"大阳岔镇","220605107":"大石人镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220605.json
// module id = 647
// module chunks = 0